const bgSecondaryColor= '#fff';
const theme = {
    bgPrimaryColor: '#e6e6e6',    
    bgSecondaryColor,
    primary: '#c80d05',
    secondary: '#1b1b1b',
    light: '#595959',
    topContainerPadding: 10,
    baseCardStyle: {
        backgroundColor: bgSecondaryColor,
        borderRadius: 10,
        padding: 10,
    },
}

export default theme;